// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_ncx-admin_ncx-admin_module_ts":"fb5b3a6072f6cbdb","src_app_ncx-dev_ncx-dev_module_ts":"29045fe53e464633"}[chunkId] + ".js";
};